import RiepilogoPrestazioniAggiuntive from "./pages/RiepilogoPrestazioniAggiuntive.vue";

export default {
    RiepilogoPrestazioniAggiuntive,
};
